import Swiper from 'swiper';

window.addEventListener('DOMContentLoaded', function () {
  const anchorsBanner = document.querySelector('.anchors-banner-block');

  if (!anchorsBanner) {
    return;
  }
  const sections = document.querySelectorAll('*[id]');
  const anchorsLinks = document.querySelectorAll(
    '.anchors-banner__links .link'
  );
  const hasOffset = window.scrollY !== undefined;
  const docBody =
    document.documentElement || document.body.parentNode || document.body;
  let scrollTop = hasOffset ? window.scrollY : docBody.scrollTop;
  let stop;
  let carousel;

  const elementIsVisibleInViewport = (el, partiallyVisible = false) => {
    const { top, bottom } = el.getBoundingClientRect();
    const elTop = top + el.offsetHeight / 2;
    const elBottom = bottom - el.offsetHeight / 2;
    const { innerHeight } = window;

    if (partiallyVisible) {
      return (
        (elTop > 0 && elTop < innerHeight) ||
        (elBottom > 0 && elBottom < innerHeight) ||
        (elTop < 0 && elBottom > innerHeight)
      );
    }

    return top >= 0 && bottom <= innerHeight;
  };

  function checkActiveAnchor() {
    sections.forEach((section) => {
      const sectionID = section.getAttribute('id');
      const anchor = document.querySelector(
        '.anchors-banner__links .link[data-anchor="' + sectionID + '"'
      );

      if (anchor) {
        if (elementIsVisibleInViewport(section, true)) {
          anchor.classList.add('active');

          if (carousel) {
            const slide = anchor.closest('.swiper-slide');
            const slidesWrapper = slide.parentNode;
            const index = Array.prototype.indexOf.call(
              slidesWrapper.children,
              slide
            );
            carousel.slideTo(index);
          }
        } else {
          anchor.classList.remove('active');
        }
      }
    });
  }

  function checkBannerVisibility() {
    const anchorsBannerSticky = document.querySelector(
      '.anchors-banner--sticky'
    );
    if (anchorsBannerSticky && scrollTop >= stop) {
      anchorsBanner.classList.add('is-sticky');
    } else {
      anchorsBanner.classList.remove('is-sticky');
    }
  }

  if (0 < anchorsLinks.length && 0 < sections.length) {
    stop = anchorsBanner.offsetTop - -140;
    checkBannerVisibility();

    const wrapper = document.querySelector('.anchors-banner');
    const nextBtn = document.querySelector(
      '.anchors-banner__links .swiper-button-next.vtx-swiper__next'
    );
    const prevBtn = document.querySelector(
      '.anchors-banner__links .swiper-button-prev.vtx-swiper__prev'
    );

    carousel = new Swiper('.anchors-banner__carousel', {
      slidesPerView: 'auto',
      spaceBetween: 20,
      watchOverflow: true, // désactive nav si pas assez de slides
      centerInsufficientSlides: true,
      navigation: {
        nextEl: '.anchors-banner__links .swiper-button-next.vtx-swiper__next',
        prevEl: '.anchors-banner__links .swiper-button-prev.vtx-swiper__prev',
      },
      observer: true,
      observeParents: true,
      on: {
        init(swiper) {
          updateNavClass(swiper);
        },
        slideChange(swiper) {
          updateNavClass(swiper);
        },
        reachBeginning(swiper) {
          updateNavClass(swiper);
        },
        reachEnd(swiper) {
          updateNavClass(swiper);
        },
        fromEdge(swiper) {
          updateNavClass(swiper);
        },
        resize(swiper) {
          updateNavClass(swiper);
        },
        update(swiper) {
          updateNavClass(swiper);
        },
        breakpoint(swiper) {
          swiper.update();
          updateNavClass(swiper);
        },
      },
    });

    function updateNavClass() {
      const isNextActive =
        nextBtn && !nextBtn.classList.contains('swiper-button-disabled');
      const isPrevActive =
        prevBtn && !prevBtn.classList.contains('swiper-button-disabled');

      const navIsUsable = Boolean(isNextActive || isPrevActive);
      wrapper.classList.toggle('nav-active', navIsUsable);
    }

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        carousel.update();
        updateNavClass(carousel);
      }, 150);
    });

    setTimeout(function () {
      checkActiveAnchor(carousel);
    }, 500);

    window.addEventListener('scroll', function () {
      scrollTop = hasOffset ? window.scrollY : docBody.scrollTop;
      checkBannerVisibility();
      this.setTimeout(function () {
        checkActiveAnchor(carousel);
      }, 200);
    });
  }

  let lastScrollTop = scrollTop;

  window.addEventListener('scroll', function () {
    scrollTop = hasOffset ? window.scrollY : docBody.scrollTop;

    if (scrollTop > lastScrollTop) {
      anchorsBanner.classList.add('scrolling-down');
      anchorsBanner.classList.remove('scrolling-up');
    } else if (scrollTop < lastScrollTop) {
      anchorsBanner.classList.add('scrolling-up');
      anchorsBanner.classList.remove('scrolling-down');
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // Pour éviter les valeurs négatives

    checkBannerVisibility();

    setTimeout(function () {
      checkActiveAnchor(carousel);
    }, 200);
  });
});
